import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path
      className="cls-1"
      d="M243.8,111.7c-1.3-6.6-5.1-12.7-9.3-18.2,0,0-13.7-33.3-32-43.8-18.2-10.5-71.1-16.4-71.1-16.4-12.6-2.1-46,4.6-56,7.7-20.3,4.2-33.5,19.7-43.9,36.5-16.7,27-23.8,58.4-18.2,88.8,1.3,7.1,3.6,13.6,6.8,19.6,19.6-10.3,37.7-24.8,42.5-43.6l-8.9-.7,5.7-5.4-12.3-.9,10.7-6.9-13.9-1.1c5.3-4,8.7-5.3,14-7.2l-11.7-1.2c5.9-5.1,11.1-6.5,17.7-8.9l-10.2-1c6.1-5.5,12-6.5,19.2-8.6l-9.9-.7c9-8.3,20.7-8.3,32.3-10.9,7.9-6.2,15.6-11.1,25.8-12.5,8.7-1.2,12-8,21.9-11.5h7.9c5.1,2.3,11.5,4.8,17.4,5.3l25,1.9c6.7.5,11.8,5.3,15.2,10.6v6.4s-3.4,8-3.4,8c-12.6,15.9-29.6,24-44.8,37.2-13.3,11.6-11.1,26-26.9,35.3-8.9,5.2-13.5,13.7-13.4,24.4-.2,8.9-1.9,17.7-8.3,24.4,0,4.7-.7,9.2-2,13.4,32.5.6,67.6-5.5,67.6-5.5,13.6-4,25.6-11.2,36.7-19.5,13.6-10.2,21.3-24.1,23.4-39.7.2-1.2.3-2.5.4-3.7,3.2-10.3,4.5-21,5.6-31.6.6-6.6,1.6-13.4.2-20Z"
    />
    <path
      className="cls-1"
      d="M149.5,83.2c3.5.6,4,4.1,6.8,5.1.9-3.2-.3-5.3-2-7.5-1.9-2.4-5.4-3.2-8.3-2-4.2,1.8-6.2,7.7-3.7,10.9l2.8-4.5c.7-1.1,3.2-2.2,4.4-2Z"
    />
  </svg>
);
export default SVGComponent;
